import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
const Wrapper = /*#__PURE__*/styled("section")({
  name: "Wrapper",
  class: "wta9b23"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "chcpc4w"
});
interface IContactTitle {
  title: string;
  subtitle: string;
}

const ContactTitle = (props: IContactTitle) => {
  return <Wrapper>
      <Container>
        <div>
          <h1>{props.title}</h1>
          <p>{props.subtitle}</p>
        </div>
      </Container>
    </Wrapper>;
};

export { ContactTitle };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");